type LoadingHandler = {
  start: () => void;
  stop: () => void;
};

let globalLoading: LoadingHandler | null = null;

export function registerLoadingHandler(handler: LoadingHandler) {
  globalLoading = handler;
}

export function startGlobalLoading() {
  globalLoading?.start();
}

export function stopGlobalLoading() {
  globalLoading?.stop();
}
